import { IoIosExit, IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import "./Container.css";

function Container({
  title,
  children,
  backNavigation,
  route,
  haveHeader = true,
}) {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  return (
    <div className="main">
      <div className="content">
        {haveHeader && (
          <div className="header">
            {backNavigation && (
              <div
                onClick={() => {
                  navigate(
                    backNavigation,
                    route ? { state: route } : { state: {} }
                  );
                }}
              >
                <IoIosArrowBack
                  style={{ fontSize: "48px", padding: "8px", color: "white" }}
                />
              </div>
            )}
            <div className="containerTitleBox">
              <p className="containerTitle">{title}</p>
            </div>
            <div
              onClick={() => {
                authCtx.logout();
                const newRoute = "/";
                navigate(newRoute);
              }}
            >
              <IoIosExit
                style={{ fontSize: "48px", padding: "8px", color: "white" }}
              />
            </div>
          </div>
        )}
        <div
          style={{ height: "90%", display: "flex", flexDirection: "column" }}
        >
          {" "}
          {children}
        </div>
      </div>
    </div>
  );
}

export default Container;
